import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { format, parse } from 'date-fns';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DateField',
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: () => false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

function isValid(v: string): boolean {
  try {
    return format(parse(v, 'dd-MM-yyyy', new Date()), 'dd-MM-yyyy') === v;
  } catch {
    //void
  }
  return false;
}

const dateRules = [
  (value: string) => {
    if (value.match(/\d{2}\-\d{2}\-\d{4}/g) !== null) return true; // eslint-disable-line

    return 'Please write dates as dd-mm-yyyy';
  },
  (value: string) => {
    if (isValid(value)) return true; // eslint-disable-line

    return 'Please use valid dates';
  },
];

const emit = __emit;

const date = ref<string>(props.modelValue);

const dateLong = computed<string>(() => {
  return isValid(date.value)
    ? format(parse(date.value, 'dd-MM-yyyy', new Date()), 'MMMM do yyyy')
    : '';
});

function update() {
  if (isValid(date.value)) {
    emit('update:modelValue', date.value);
  } else {
    emit('update:modelValue', null);
  }
}

watch(
  () => props.modelValue,
  (v: string) => {
    date.value = v;
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, {
    label: props.label,
    placeholder: "dd-mm-yyyy",
    rules: dateRules,
    required: __props.required,
    hint: dateLong.value,
    modelValue: date.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
    onChange: update,
    onKeydown: update,
    onKeyup: update
  }, null, 8, ["label", "required", "hint", "modelValue"]))
}
}

})